const privacyPolicyPk = {
	breadcrumbs: { home: 'ہوم', title: 'پرائیویسی پالیسی' },
	hero: {
		title: 'پرائیویسی پالیسی',
		subtitle: 'آپ کے ذاتی ڈیٹا اور پرائیویسی کا تحفظ ہماری ترجیح ہے'
	},
	principles: [
		{ title: 'ڈیٹا سکیورٹی', description: 'ہم آپ کی ذاتی معلومات کو اعلیٰ درجے کی سکیورٹی کے ساتھ محفوظ رکھتے ہیں' },
		{ title: 'شفافیت', description: 'ہم واضح کرتے ہیں کہ ہم کیا معلومات جمع کرتے ہیں اور کیوں' },
		{ title: 'صارف کا کنٹرول', description: 'آپ کو اپنی معلومات پر مکمل اختیار حاصل ہے' },
		{ title: 'پرائیویسی کا تحفظ', description: 'آپ کی اجازت کے بغیر ہم معلومات شیئر نہیں کرتے' }
	],
	dataTypes: [
		{ category: 'ذاتی معلومات', items: ['نام', 'فون نمبر', 'ای میل ایڈریس', 'تاریخ پیدائش'], purpose: 'آپ کا اکاؤنٹ بنانا اور مینج کرنا' },
		{ category: 'پتہ کی معلومات', items: ['گھر کا پتہ', 'ڈلیوری پتہ', 'تحصیل', 'ضلع'], purpose: 'ڈلیوری اور مقامی خدمات' },
		{ category: 'ادائیگی کی معلومات', items: ['موبائل بینکنگ نمبر', 'بینک اکاؤنٹ', 'لین دین کی تاریخ'], purpose: 'محفوظ ادائیگی کی پروسیسنگ' },
		{ category: 'استعمال کی معلومات', items: ['ایپ استعمال کی ہسٹری', 'تلاشیں', 'پسندیدہ فہرست'], purpose: 'شخصی تجربہ فراہم کرنا' }
	],
	usage: {
		title: 'ہم معلومات کیسے استعمال کرتے ہیں',
		primaryTitle: 'بنیادی استعمال',
		primary: ['اکاؤنٹ بنانا اور مینج کرنا', 'آرڈر اور ڈلیوری پروسیس کرنا', 'کسٹمر سپورٹ فراہم کرنا', 'ادائیگیوں کی پروسیسنگ'],
		improveTitle: 'بہتری کے لئے استعمال',
		improve: ['ذاتی نوعیت کی تجاویز', 'سروس کے معیار میں بہتری', 'سکیورٹی اور فراڈ سے بچاؤ', 'مارکیٹ ریسرچ اور اینالیٹکس']
	},
	rights: {
		title: 'آپ کے حقوق',
		items: [
			{ right: 'رسائی کا حق', description: 'جانیں کہ ہم آپ کے بارے میں کیا معلومات رکھتے ہیں' },
			{ right: 'تصحیح کا حق', description: 'غلط یا پرانی معلومات درست کروانے کا حق' },
			{ right: 'حذف کرنے کا حق', description: 'اپنی ذاتی معلومات حذف کروانے کی درخواست' },
			{ right: 'ڈیٹا پورٹیبلیٹی', description: 'اپنی معلومات کی کاپی ڈاؤن لوڈ کریں' }
		]
	},
	security: {
		title: 'سکیورٹی اقدامات',
		intro: 'ہم آپ کی معلومات کے تحفظ کے لیے درج ذیل اقدامات کرتے ہیں:',
		measures: ['SSL انکرپشن', 'باقاعدہ سکیورٹی آڈٹ', 'ٹو فیکٹر تصدیق', 'ڈیٹا بیک اپ اور ریکوری', 'ایکسس کنٹرول سسٹمز', 'باقاعدہ سسٹم اپڈیٹس']
	},
	cookies: {
		title: 'کوکیز پالیسی',
		usageTitle: 'کوکیز کا استعمال',
		p1: 'ہم آپ کے براؤزنگ تجربے کو بہتر بنانے اور سروسز کو شخصی بنانے کے لیے کوکیز استعمال کرتے ہیں۔ کوکیز چھوٹی ٹیکسٹ فائلز ہوتی ہیں جو آپ کے ڈیوائس پر محفوظ ہوتی ہیں۔',
		p2: 'آپ براؤزر سیٹنگز میں کوکیز کو کنٹرول کر سکتے ہیں۔ کوکیز کو غیر فعال کرنے سے کچھ سروسز صحیح طرح کام نہیں کر سکتیں۔'
	},
	sharing: {
		title: 'تیسری پارٹی سے شیئرنگ',
		intro: 'ہم صرف ان صورتوں میں معلومات شیئر کر سکتے ہیں:',
		authorizedTitle: 'مجوزہ شیئرنگ',
		notDoTitle: 'ہم یہ نہیں کرتے',
		authorized: ['ڈلیوری پارٹنرز (پتہ کے لیے)', 'پیمنٹ گیٹ ویز (لین دین کے لیے)', 'عدالتی حکم پر قانونی تقاضے'],
		notDo: ['اشتہاریوں کو فروخت', 'اجازت کے بغیر مارکیٹنگ', 'غیر ضروری تیسری پارٹی سے شیئرنگ']
	},
	retention: {
		title: 'ڈیٹا برقرار رکھنے کی پالیسی',
		retentionTitle: 'مدت',
		retentionText: 'جب تک آپ کا اکاؤنٹ فعال ہے یا سروس فراہم کرنے کے لیے ضروری ہے ہم معلومات رکھتے ہیں۔',
		deleteTitle: 'حذف کرنا',
		deleteText: 'اکاؤنٹ بند ہونے کے بعد، قانونی ضرورت نہ ہونے کی صورت میں 30 دن کے اندر معلومات حذف کر دی جاتی ہیں۔'
	},
	updates: {
		title: 'پالیسی اپڈیٹس',
		alert: 'یہ پرائیویسی پالیسی وقتاً فوقتاً اپڈیٹ کی جا سکتی ہے',
		notify: 'کسی بھی تبدیلی کی صورت میں ہم ای میل یا ایپ نوٹیفکیشنز کے ذریعے اطلاع دیں گے۔ اہم تبدیلیوں کے لیے آپ کی منظوری لی جائے گی۔',
		lastUpdatedPrefix: 'آخری اپڈیٹ:',
		lastUpdatedDate: 'دسمبر 2023'
	},
	contact: {
		title: 'پرائیویسی سے متعلق رابطہ',
		subtitle: 'اگر اس پالیسی یا آپ کے ذاتی ڈیٹا کے بارے میں کوئی سوال ہو تو ہم سے رابطہ کریں',
		button: 'ہم سے رابطہ کریں',
		email: 'privacy@grameenbazar.com'
	}
};

export default privacyPolicyPk;


